module.exports = __webpack_public_path__ + "r-v3/img/record.f03aff36.svg";